/* eslint-disable import/no-extraneous-dependencies */
import process from 'process/browser';

if (typeof globalThis.process === 'undefined') {
  globalThis.process = process;
}
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
  window.process = process;
}
